<template>
  <div>
    <div class="content-box">
      <GraficoModalComponent
        v-if="current.id"
        :id="current.id"
        :modulo="'inv'"
        :path="'ent_traslado'"
      />
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <router-link
                  class="btn btn-sm btn-outline-dark"
                  :to="{ name: 'inventario-entrada_traslado' }"
                >
                  <i class="fa fa-reply"></i>
                  Regresar
                </router-link>
                <h5 class="form-header">
                  Entrada por Traslado #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">
                      {{ current.estado_str }}
                    </span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      &nbsp;
                      <!-- <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="finalizar"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Finalizar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.tienda_origen &&
                            current.errors.tienda.length > 0,
                        }"
                        >Tienda Origen</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tienda_origen"
                        :disabled="current.id"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda_origen"
                        class="form-text text-danger"
                        >{{ current.errors.tienda_origen[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.tienda && current.errors.tienda.length > 0,
                        }"
                        >Tienda Destino</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tienda_destino"
                        :disabled="current.id"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda"
                        class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.fecha && current.errors.fecha.length > 0,
                        }"
                        >Fecha</label
                      >
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Tipo</label>
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tipo_traslado"
                        :disabled="current.id"
                      >
                        <option value="T">Traslado</option>
                        <option value="D">Devolucion</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda"
                        class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input
                        :disabled="true"
                        class="form-control"
                        v-model="current.usuario"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <router-link
                    v-if="tarima"
                    class="btn btn-md btn-outline-success"
                    :to="{
                      name: 'inventario-tarima-editar',
                      params: { id: tarima.id },
                    }"
                    ><span class="text-dark"><i class="fas fa-share"></i> Tarima:</span>
                    <span class="badge">#{{ tarima.numero }}</span></router-link
                  >
                  <router-link
                    v-if="tarima"
                    class="btn btn-md btn-outline-success"
                    :to="{
                      name: 'inventario-salida_traslado-editar',
                      params: { id: tarima.salida_traslado_e },
                    }"
                    ><span class="text-dark"><i class="fas fa-share"></i> Salida:</span>
                    <span class="badge"
                      >#{{ tarima.salida_e_objeto.numero }}</span
                    ></router-link
                  >
                </div>
                <br />
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th class="text-center">Posición</th>
                        <th class="text-center">Enviada</th>
                        <th class="text-center">Recibida</th>
                        <th class="text-center">Inconsistencia</th>
                        <th
                          v-if="current.estado_str != 'Finalizado'"
                          class="text-center nowrap"
                        >
                          Estado
                        </th>
                        <th v-if="current.estado == 'A'" class="text-center">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.entradastrasladod_set"
                        v-bind:key="detalle.id"
                      >
                        <td>{{ detalle.producto.sku }}</td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td>
                          {{ detalle.posicion_obj.id }} -
                          {{ detalle.posicion_obj.barra }}
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span style="color: #0646bf">
                            <i class="fas fa-truck-loading"></i>
                            {{ detalle.enviada }}
                          </span>
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span class="text-success">
                            <i class="fas fa-plus"></i>
                            {{ detalle.cantidad }}
                          </span>
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span v-if="detalle.salida_traslado_d" class="text-danger">{{
                            detalle.salida_traslado_d.inconsistencia
                          }}</span>
                        </td>
                        <td v-if="current.estado_str != 'Finalizado'" class="text-center">
                          <span
                            class="status-pill smaller green"
                            v-if="detalle.estado == 'A'"
                          ></span>
                          <span
                            class="status-pill smaller red"
                            v-if="detalle.estado == 'B'"
                          ></span>
                        </td>
                        <td
                          v-if="current.estado == 'A'"
                          class="text-center"
                          style="width: 200px"
                        >
                          <button
                            class="btn btn-sm btn-dark mr-1"
                            type="button"
                            v-if="current.estado == 'A'"
                            @click="editarDetalleShowmodal(detalle)"
                          >
                            <i class="fas fa-edit"></i>
                            Editar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class>
                    <button
                      v-if="current.estado == 'A'"
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="showModalAddDetail"
                    >
                      <i class="fa fa-plus"></i>
                      Agregar Producto
                    </button>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="form-buttons-w">
                  <button
                    class="btn btn-md btn-success"
                    v-if="current.id == null"
                    type="submit"
                  >
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqTraslado"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors && currentDetalle.errors.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="currentDetalle"
                    ></ProductoSelectComponentV2>
                    <small v-if="currentDetalle.errors" class="form-text text-danger">{{
                      currentDetalle.errors.detail
                    }}</small>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Posicion</label>

                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.posicion"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option
                        v-for="(detalle, key) in posiciones"
                        :value="detalle.id"
                        :key="key"
                      >
                        Posición: {{ detalle.id }}, -- Tienda:
                        {{ detalle.tienda }}
                        {{ detalle.descripcion }}
                      </option>
                    </select>
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.posicion[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.producto_lote &&
                        currentDetalle.errors.producto_lote.length > 0,
                    }"
                    >Lote</label
                  >
                  <select
                    v-model="currentDetalle.codigo_lote"
                    v-if="
                      currentDetalle.productolote_set != null &&
                      currentDetalle.productolote_set.length > 0
                    "
                    class="form-control"
                    autofocus="autofocus"
                  >
                    <option
                      v-for="detalle in currentDetalle.productolote_set"
                      :value="detalle.id"
                      v-bind:key="detalle.id"
                    >
                      Lote: {{ detalle.codigo_lote }} || Fab:
                      {{ detalle.fecha_fabricacion }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                  <small
                    v-if="currentDetalle.errors && currentDetalle.errors.producto_lote"
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.producto_lote }}</small
                  >
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                      >Cantidad en Unidades</label
                    >
                    <input
                      v-model="currentDetalle.cantidad"
                      class="form-control"
                      placeholder="cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                    />
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.cantidad"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              :disabled="
                !(
                  currentDetalle.productolote_set != null &&
                  currentDetalle.productolote_set.length > 0
                )
              "
              class="btn btn-primary"
              @click="agregaDetalle"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalModDetailSalida"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Producto</label>
                    <input
                      v-model="currentDetalleMod.producto.sku"
                      class="form-control"
                      placeholder="Producto"
                      readonly="readonly"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Cantidad en Unidades</label>
                    <input
                      v-model="currentDetalleMod.cantidad"
                      class="form-control"
                      placeholder="Cantidad Unidades"
                      type="text"
                      style="text-align: center; font-size: 200%"
                    />
                    <small
                      v-if="currentDetalleMod.errors && currentDetalleMod.errors.cantidad"
                      class="form-text text-danger"
                      >{{ currentDetalleMod.errors.cantidad[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Lote</label>
                    <select
                      :disabled="true"
                      v-if="currentDetalleMod.productolote_set"
                      v-model="currentDetalleMod.producto_lote"
                      class="form-control"
                      autofocus="autofocus"
                    >
                      <option
                        v-for="detalle in currentDetalleMod.productolote_set"
                        :value="detalle"
                        v-bind:key="detalle.id"
                      >
                        Lote: {{ detalle.codigo_lote }} || Vence:
                        {{ detalle.fecha_vence }}
                      </option>
                    </select>
                    <small
                      v-if="
                        currentDetalleMod.errors && currentDetalleMod.errors.producto_lote
                      "
                      class="form-text text-danger"
                      >{{ currentDetalleMod.errors.producto_lote[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Posicion</label>
                    <select
                      :disabled="true"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalleMod.posicion"
                    >
                      <option
                        v-for="(detalle, key) in posiciones"
                        :value="detalle.posicion_id"
                        :key="key"
                      >
                        {{ detalle.codigo_barra }}
                      </option>
                    </select>
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.posicion }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="editarDetalle" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import EntradaTrasladoService from "@/services/inventario/EntradaTrasladoService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import PosicionesService from "@/services/inventario/PosicionesService";
import GraficoModalComponent from "@/components/commons/GraficoModalComponent";

var name = "John Smith";
$("#name").text(name);
export default {
  components: {
    ProductoSelectComponentV2,
    GraficoModalComponent,
  },
  data() {
    return {
      tarima: [],
      testVal: null,
      current: {
        id: null,
        estado_str: null,
        tienda_origen: "",
        tienda_destino: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        entradastrasladod_set: [],
        tipo_traslado: "T",
      },

      productos: [],
      options: [],
      posiciones: [],
      producto_lote: [],
      currentDetalleMod: {
        id: null,
        cantidad: 0,
        precio_unitario: 0.0,
        producto: [],
        tarima: "",
        producto_lote: [],
        posicion: "",
        posicion_id: "",
        errors: [],
      },
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        impr: 0,
        productolote_set: [],
        codigo_lote: 0,
        producto: "",
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshTarima();
    }
  },
  methods: {
    refreshTarima() {
      let self = this;
      DynamicService.fetch("wms", "tarima", {
        entrada_traslado_e__id: this.$route.params.id,
      }).then((response) => {
        self.tarima = response.data.results[0];
      });
    },
    editarDetalleShowmodal(detalle) {
      let self = this;
      ProductosService.getById(detalle.producto.sku).then((res) => {
        self.currentDetalleMod.productolote_set = res.data.productolote_set;
        self.currentDetalleMod.tarima = detalle.tarima;
        self.currentDetalleMod.posicion = detalle.posicion;
        self.currentDetalleMod.cantidad = detalle.cantidad;
        self.currentDetalleMod.producto_lote = detalle.producto_lote;
        self.currentDetalleMod.id = detalle.id;
        self.currentDetalleMod.producto = detalle.producto;
      });
      PosicionesService.fetch({
        tienda: self.current.tienda,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalModDetailSalida").modal();
    },
    editarDetalle() {
      let self = this;
      let detMod = Object.assign({}, self.currentDetalleMod);
      if (detMod.posicion != null) {
        if (detMod.posicion.posicion_id) {
          detMod.posicion = detMod.posicion.posicion_id;
        }
      }
      detMod.producto_lote = detMod.producto_lote.id;
      detMod.id = detMod.id;
      detMod.cantidad = detMod.cantidad;
      detMod.tarima = detMod.tarima;
      EntradaTrasladoService.modificar_detalle(self.current.id, detMod)
        .then((response) => {
          Notifications.alert.success(
            "Salida por Traslado",
            "¡Modificación Satisfactoria!"
          );
          self.refreshCurrent();
          self.refreshDetalleModDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalleMod.errors = error.response.data;
        });
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshPosiciones();
      // self.refreshUnidadMedida(producto);
    },
    refreshPosiciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-posicion", {
        tienda: self.current.tienda_destino,
        quitar_paginacion: true,
      }).then((res) => {
        self.posiciones = res.data;
        if (res.data.length > 0) {
          self.currentDetalle.posicion = res.data[0].id;
        }
        self.llenarLote();
      });
    },
    llenarLote(value) {
      let self = this;
      DynamicService.getById("cat", "productos", self.currentDetalle.producto.sku).then(
        (res) => {
          self.currentDetalle.productolote_set = res.data.productolote_set;
        }
      );
    },
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
      });
    },
    refreshCurrent() {
      let self = this;
      EntradaTrasladoService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda_origen = response.data.tienda_origen.codigo;
        self.current.tienda_destino = response.data.tienda_destino.codigo;
        self.current.tipo_traslado = response.data.tipo_traslado;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
        self.currentDetalle.posicion = 0;
      });
    },

    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      current.fecha = self.current.fecha.replace(/\//g, "-");
      if (current.salida_traslado_e) {
        current.salida_traslado_e = self.current.salida_traslado_e.id;
      }
      console.log(current.salida_traslado_e);
      EntradaTrasladoService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-entrada_traslado-editar",
              params: { id: response.data.id },
            });
            document.location.reload();
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          self.current.errors = error.response.data;
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqTraslado").modal();
      });
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      EntradaTrasladoService.agregarDetalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Entrada por Traslado",
            "Se ha guardado la Información."
          );
          $("#modalAddDetailReqTraslado").modal("hide");
          self.refreshCurrent();
        })
        .catch((error) => {
          console.log(error.response);
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          EntradaTrasladoService.eliminarDetalle(detalle.entrada_traslado_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },

    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          EntradaTrasladoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          EntradaTrasladoService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    finalizar() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "Desea finalizar la transacción?",
        "Si Finalizar",
        function () {
          EntradaTrasladoService.finalizar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha finalizado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Finalizar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          EntradaTrasladoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    imprimir() {
      let op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/entrada_traslado/Entrada_Traslado.jrxml&id=${op}`
      );
    },
    refreshDetalleModDefault() {
      let self = this;
      (self.currentDetalleMod = {
        id: null,
        cantidad: 0,
        precio_unitario: 0.0,
        producto: [],
        tarima: "",
        producto_lote: [],
        posicion: "",
        posicion_id: "",
        errors: [],
      }),
        (self.currentDetalle = {
          cantidad: "",
          cantidad_um: "",
          unidad_medida: null,
          proveedor: null,
          producto: {
            sku: null,
            unidad_medida: null,
            errors: [],
          },
          errors: [],
        });
    },
  },
};
</script>
